import { render, staticRenderFns } from "./classLoader.vue?vue&type=template&id=27dd8864&"
import script from "./classLoader.vue?vue&type=script&lang=js&"
export * from "./classLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports